/*@ngInject*/
const NotificationPreferenceRepository = function (baseCachedRepository) {

    angular.extend(this, baseCachedRepository);

    this.getCacheName = function () {
        return 'notificationPreferenceRepository';
    };

    this.getCacheCapacity = function () {
        return 10;
    };

    this.getNotificationEmailTemplate = function (name, context) {
        let url = `/rest/NotificationEmailTemplate/name?notificationEmailTemplateName=${name}`,
            cacheKey = `${name}email`;

        if (!_.isNull(context)) {
            _.each(context, function (value, key) {
                url += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                cacheKey += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            });
        }

        return this.get(cacheKey, url);
    };

    this.getNotificationPopupTemplate = function (name, context) {
        let url = `/rest/NotificationPopupTemplate/name?notificationPopupTemplateName=${name}`,
            cacheKey = `${name}popup`;

        if (!_.isNull(context)) {
            _.each(context, function (value, key) {
                url += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                cacheKey += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            });
        }

        return this.get(cacheKey, url);
    };

    this.processResponseData = function (responseData) {
        if (!_.isNil(responseData.confirmationMessage)) {
            responseData.confirmationMessage = responseData.confirmationMessage.replace(/\\n/g, '\n');
        }
        if (!_.isNil(responseData.body)) {
            responseData.body = responseData.body.replace(/\\n/g, '\n');
        }
        return responseData;
    };
};

angular.module('umCore')
    .service('notificationPreferenceRepository', NotificationPreferenceRepository);
